import { adminLayoutWrap } from '@middlewares';
import ConnectedIntegrationsPageV2 from './pages/ConnectedIntegrationsPageV2';
import IntegrationResourcesPage from './pages/IntegrationResourcesPage';

export const routes = {
  ConnectedIntegrations: {
    label: 'Connected Integrations',
    path: '/catalog/connected',
    page: adminLayoutWrap(<ConnectedIntegrationsPageV2 />),
  },
  IntegrationResources: {
    label: 'Integration Resources',
    path: '/catalog/integration-resources/:id',
    page: adminLayoutWrap(<IntegrationResourcesPage />),
  },
};
